import React from "react";
import styled from "styled-components";

type IconType = React.ReactNode;

interface ErrorMessageProps {
  margin?: string;
  align?: string;
}

interface ErrorMessageWithIconProps {
  icon: IconType;
  children: React.ReactNode;
  className?: string;
}

const ErrorMessage = styled.p<ErrorMessageProps>`
  color: #a94442;
  min-height: 20px;
  margin-top: ${(props) => props.margin || "10px"};
  font-size: 14px;
  text-align: ${(props) => props.align || "left"};
`;

export default ErrorMessage;

interface WrapperProps {
  children: React.ReactNode[];
}

const Wrapper = styled.div<WrapperProps>`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ErrorMessageWithIcon: React.FC<ErrorMessageWithIconProps> = ({
  icon,
  children,
  className
}) => (
  <Wrapper className={className}>
    {icon}
    <ErrorMessage align="center">{children}</ErrorMessage>
  </Wrapper>
);

export { SearchIcon } from "./search-icon";
export { ErrorMessageWithIcon };
